import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Plus, Images } from "lucide-react";
import { ParallaxBackground } from "@/components/site/ParallaxBackground";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/site/Reveal";
import { SmokeReveal } from "@/components/site/SmokeReveal";
import { GALLERY, FIGHTERS, FIGHTERS_1, ASSETS } from "@/lib/data";

const GROUPS = [
  {
    id: "1",
    title: "PAHLAWAN 1.0",
    logo: ASSETS.logo1,
    subtitle: "Where it all began · 22 February 2025 · Stadium Titiwangsa",
    images: [
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/a2mp5qt2_481191661_18360070945124955_6257512629358322841_n.jpg",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/aqip5asc_481176247_18360070075124955_1876366331683141607_n.jpg",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/e4g5b1ug_480897118_18360070114124955_6988453803867492633_n.jpg",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/tkr2tw5g_481215028_18360070096124955_6054246218186919502_n.jpg",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/bu0k5o0x_481860303_18360070126124955_1229753101097571073_n.jpg",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/tjjzqm7z_496947785_1253477340119101_3001717565090946805_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/1e2fac7r_498587571_1253477300119105_5828643999279238020_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/73xudhtn_498613763_1253477343452434_4908854938073279477_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/b2loowdy_497333227_1253477330119102_82682122150377631_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/3214vn4u_497384624_1253477310119104_1090974489847604849_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/n5kvdvpr_498547268_1253478200119015_2185285732980104483_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/ejnogdon_498140312_1253478140119021_2535125470735511700_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/35k99jza_497837738_1253478123452356_4883518324942991628_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/3kaaqmgz_497457115_1253477896785712_2984778976257339478_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/fsr28g0e_497932009_1253477273452441_7095850793467804184_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/xsnka9cc_498688952_1253478300119005_1332126513682757477_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/poqv3l1r_498336850_1253478106785691_4946860784877612966_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/ubispla4_498550553_1253478100119025_4893101400386104210_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/qjrxyb7a_498004555_1253478143452354_4094208261163025885_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/d0d9x11h_498842726_1253478226785679_2028584252441404606_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/69f1x40z_498551934_1253479016785600_2302721797482611835_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/gfu3o1c4_498659363_1253478990118936_7773688986283998002_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/01hbu7vg_498548820_1253478230119012_5249431871884846432_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/hdblco1a_497422569_1253478363452332_6397516525795705037_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/kv0y0wfy_498535269_1253478023452366_420600735815501424_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/g0mzbx94_495479489_18370269370124955_7706616269721399308_n.jpg",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/xxah87hb_498587261_1253479320118903_4588531740805625474_n.webp",
      "https://customer-assets-jai6qajn.emergentagent.net/job_pahlawan-tickets/artifacts/nqmzxck1_498600146_1253479063452262_3325089176747047407_n.webp",
    ],
    fighters: FIGHTERS_1,
  },
  {
    id: "2",
    title: "PAHLAWAN 2.0",
    logo: ASSETS.logo,
    subtitle: "WPIMC 2.0 · Superbon & Jojo Interview",
    images: GALLERY.map((g) => g.src),
    fighters: FIGHTERS,
  },
  {
    id: "3",
    title: "PAHLAWAN 3.0",
    logo: ASSETS.eventLogo,
    subtitle: "Coming November 2026 · Kuala Lumpur",
    images: [],
    fighters: [],
  },
];

const GalleryBlock = ({ group, onOpen }) => (
  <section className="mb-24" data-testid={`gallery-group-${group.id}`}>
    <SmokeReveal tint={group.id === "2" ? "cyan" : "pink"} className="mb-10 max-w-3xl">
      <p className="font-mono-cap mb-3 text-[11px] text-neon-cyan">Chapter {group.id}</p>
      {group.logo ? (
        <img
          src={group.logo}
          alt={group.title}
          className="h-auto w-64 object-contain sm:w-80"
          style={{ filter: "drop-shadow(0 0 30px rgba(255,0,216,0.3))" }}
        />
      ) : (
        <h2 className="font-display text-4xl leading-[0.95] sm:text-5xl">
          {group.title.split(" ")[0]} <span className="gradient-text">{group.title.split(" ")[1]}</span>
        </h2>
      )}
      <p className="mt-4 font-body text-slate-400">{group.subtitle}</p>
    </SmokeReveal>

    {group.images.length > 0 && (
      <div className="relative overflow-hidden" data-testid={`gallery-${group.id}-marquee`}>
        <div className="flex w-max gap-4 marquee-slow">
          {[...group.images, ...group.images].map((src, i) => (
            <button
              key={i}
              onClick={() => onOpen(src)}
              className="group relative h-[200px] w-[240px] shrink-0 overflow-hidden rounded-2xl border border-white/10 transition-colors hover:border-neon-pink/60 sm:h-[230px] sm:w-[280px]"
              data-testid={`gallery-${group.id}-item-${i}`}
            >
              <img src={src} alt="" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-void/70 via-transparent to-transparent opacity-70 transition-opacity group-hover:opacity-90" />
              <Plus className="absolute bottom-3 left-3 h-4 w-4 text-neon-cyan" />
            </button>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-void to-transparent sm:w-28" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-void to-transparent sm:w-28" />
      </div>
    )}

    {group.images.length === 0 && group.fighters.length === 0 && (
      <Reveal className="flex h-56 flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-white/15 bg-white/[0.02] text-center">
        <Images className="h-7 w-7 text-neon-violet" />
        <p className="font-sub text-sm font-semibold text-slate-300">Photos coming soon</p>
        <p className="font-mono-cap text-[10px] text-slate-500">This gallery will be updated shortly</p>
      </Reveal>
    )}

    {group.fighters && group.fighters.length > 0 && (
      <div className="mt-12">
        <p className="mb-5 font-mono-cap text-[11px] text-neon-cyan">Fighter Roster</p>
        <div className="relative overflow-hidden">
          <div className="flex w-max gap-5 marquee-slow">
            {[...group.fighters, ...group.fighters].map((img, i) => (
              <button
                key={i}
                onClick={() => onOpen(img)}
                className="group relative w-[180px] shrink-0 overflow-hidden rounded-2xl border border-white/10 transition-colors hover:border-neon-pink/60 sm:w-[210px]"
                data-testid={`gallery-fighter-${i}`}
              >
                <img src={img} alt="" className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </button>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-void to-transparent sm:w-28" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-void to-transparent sm:w-28" />
        </div>
      </div>
    )}
  </section>
);

export default function GalleryPage() {
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  }, []);

  return (
    <div className="relative min-h-screen text-white" data-testid="gallery-page">
      <ParallaxBackground />
      <Header />
      <main className="mx-auto max-w-7xl px-4 pt-32 sm:px-8 lg:pt-40">
        <Reveal className="mb-16">
          <p className="font-mono-cap mb-4 text-[11px] text-neon-cyan">The Archive</p>
          <h1 className="font-display text-5xl leading-[0.92] sm:text-7xl">
            PAHLAWAN <span className="gradient-text">GALLERY</span>
          </h1>
          <p className="mt-5 max-w-2xl font-body text-lg text-slate-300">
            Every era, every warrior, every unforgettable night. Relive the journey across all Pahlawan Championship
            chapters.
          </p>
        </Reveal>

        {GROUPS.map((g) => (
          <GalleryBlock key={g.id} group={g} onOpen={setLightbox} />
        ))}
      </main>
      <Footer />

      <AnimatePresence>
        {lightbox && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[70] flex items-center justify-center bg-void/90 p-4 backdrop-blur-md"
            onClick={() => setLightbox(null)}
            data-testid="gallery-lightbox"
          >
            <button className="absolute right-5 top-5 rounded-full bg-black/50 p-2 text-white hover:bg-neon-pink">
              <X className="h-5 w-5" />
            </button>
            <motion.img
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              src={lightbox}
              alt=""
              onClick={(e) => e.stopPropagation()}
              className="max-h-[88vh] w-auto rounded-2xl border border-neon-violet/40 object-contain glow-ring"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
